import getObjectKey from 'lib/object/getObjectKey'

interface PropertyRatesKeyParams {
  propertyId: string | undefined;
  checkIn: string | undefined;
  checkOut: string | undefined;
  occupancies: Array<App.Occupants>;
  dynamicAvailability: boolean;
}

function buildPropertyRatesKey({
  propertyId,
  checkIn,
  checkOut,
  occupancies,
  dynamicAvailability,
}: PropertyRatesKeyParams): string {
  if (!(propertyId && checkIn && checkOut && occupancies.length)) {
    return ''
  }
  return getObjectKey({
    propertyId,
    checkIn,
    checkOut,
    rooms: occupancies,
    dynamicAvailability,
  })
}

export default buildPropertyRatesKey
